import type { Vehicle } from "@/types";

export default function HostCard({ vehicle }: { vehicle: Vehicle }) {
  const name = vehicle.owner_name || "Gari Host";
  const initials = name
    .split(" ")
    .map((part) => part.charAt(0))
    .slice(0, 2)
    .join("")
    .toUpperCase();

  return (
    <div className="rounded-2xl surface-card p-6">
      <div className="flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-4">
          <span className="flex h-16 w-16 items-center justify-center overflow-hidden rounded-full bg-secondary-500/25 font-heading text-xl font-semibold text-secondary-200">
            {vehicle.owner_avatar ? (
              <img src={vehicle.owner_avatar} alt={name} className="h-full w-full object-cover object-top" />
            ) : (
              initials
            )}
          </span>
          <div>
            <p className="flex items-center gap-2 font-heading text-lg font-semibold text-foreground-950">
              {name}
              <i className="ri-verified-badge-fill text-primary-500" title="Verified host"></i>
            </p>
            <p className="mt-0.5 text-sm text-foreground-500">
              Hosting since {vehicle.owner_since || 2021} · {vehicle.owner_trips || 40}+ trips hosted
            </p>
            <span className="mt-2 inline-flex items-center gap-1.5 rounded-full bg-primary-500/12 px-2.5 py-1 text-xs font-medium text-primary-400">
              <i className="ri-award-line"></i> All-star host
            </span>
          </div>
        </div>

        <div className="grid grid-cols-3 gap-4 text-center sm:text-right">
          <div>
            <p className="font-heading text-lg font-semibold text-foreground-950">{Number(vehicle.rating ?? 4.8).toFixed(1)}</p>
            <p className="text-xs text-foreground-500">rating</p>
          </div>
          <div>
            <p className="font-heading text-lg font-semibold text-foreground-950">{vehicle.reviews_count ?? 0}</p>
            <p className="text-xs text-foreground-500">reviews</p>
          </div>
          <div>
            <p className="font-heading text-lg font-semibold text-foreground-950">~1h</p>
            <p className="text-xs text-foreground-500">reply time</p>
          </div>
        </div>
      </div>

      <div className="mt-6 flex flex-wrap gap-3">
        <button
          type="button"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-200 bg-background-50 px-4 py-2.5 text-sm font-medium text-foreground-900 transition-colors hover:border-primary-500/60"
        >
          <i className="ri-message-3-line"></i> Message host
        </button>
        <span className="inline-flex items-center gap-2 rounded-md bg-background-200/50 px-4 py-2.5 text-sm text-foreground-600">
          <i className="ri-shield-check-line text-accent-400"></i> Identity verified by Gari
        </span>
      </div>
    </div>
  );
}